import { useState, useEffect } from 'react';

export const useResize = (dimension: number): boolean => {

  const [ resize, setResize ] = useState(true);

  useEffect(() => {
    window.innerWidth >= dimension ? setResize(false) : setResize(true);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const handleResize = () => {
    window.innerWidth >= dimension ? setResize(false) : setResize(true);
  };

  return resize;
};
